module.exports = __webpack_public_path__ + "static/img/feeds.bbc14205.png";